import React, { useCallback, useMemo } from 'react';
import { DatePicker } from '../../../DatePicker';
export var FilterEditorDateCondition = function FilterEditorDateCondition(_ref) {
  var condition = _ref.condition,
      conditionType = _ref.conditionType,
      conditionValue = _ref.conditionValue,
      onConditionValueChange = _ref.onConditionValueChange;
  var label = condition.label;

  var _conditionType$getAtt = conditionType.getAttributes(),
      enableTimePicker = _conditionType$getAtt.enableTimePicker,
      formatDateTime = _conditionType$getAtt.formatDateTime;

  var _ref2 = conditionValue || {},
      value = _ref2.value;

  var dateValue = useMemo(function () {
    if (typeof value === 'string') {
      return new Date(value);
    }

    if (!value) {
      return null;
    }

    return value;
  }, [value]);
  var onDateValueChange = useCallback(function (newValue) {
    onConditionValueChange({
      value: newValue
    });
  }, [onConditionValueChange]);
  return React.createElement(DatePicker, {
    enableMinWidthAutoCorrection: false,
    wide: true,
    label: label,
    dateValue: dateValue,
    onDateValueChange: onDateValueChange,
    enableTimePicker: enableTimePicker,
    formatDateTime: formatDateTime
  });
};